import React from "react";
import Link from "next/link";
import classNames from "classnames";
import { Expert } from "@models/Expert";

interface ISimpleExpertLinkCard {
  expert: Expert;
  isAmp?: boolean;
  className?: string;
}

const SimpleExpertLinkCard = (props: ISimpleExpertLinkCard): JSX.Element => {
  const { expert, isAmp, className } = props,
    classes = classNames("simple-expert-link-card", className),
    displayName = [expert.firstName || "", expert.lastName || ""].filter(Boolean).join(" ");

  return (
    <Link href={`/teams/${expert.slug}`}>
      <a className={classes}>
        <div className="img-container">
          {isAmp ? (
            <amp-img alt={expert.slug} src={expert.image?.src} width={150} height={150} layout="responsive"></amp-img>
          ) : (
            <img className="avatar" src={expert.image?.src || ""} loading="lazy" width={300} height={311} alt={expert.slug} />
          )}
        </div>
        <h2 className="display-name">
          {displayName}
          {expert.credentials?.length ? (
            <span className="d-none d-md-inline">
              <span>,&nbsp;</span>
              <span className="credentials">{expert.credentials.join(", ")}</span>
            </span>
          ) : (
            <></>
          )}
        </h2>
        {expert.position ? <p className="position">{expert.position}</p> : <></>}
      </a>
    </Link>
  );
};

export default SimpleExpertLinkCard;
